import React from 'react';
import styled from 'styled-components';
import kebabCase from 'lodash.kebabcase';
import CoreInput from 'gatsby-theme-core/src/components/form-elements/input';
import Wrapper from './wrapper';
import Label from './label';

const getDate = (minDaysFromNow) => {
  const date = new Date();
  date.setDate(date.getDate() + Number(minDaysFromNow));
  return date;
};

const formatDate = (date, { type = 'date' }) => {
  if (!date) {
    return null;
  }
  const parsedDate = new Date(date);
  if (type === 'datetimeLocal') {
    return `${parsedDate.toISOString().split('T')[0]}T00:00`;
  }
  return parsedDate.toISOString().split('T')[0];
};

const DateComponent = ({
  className,
  name,
  label = null,
  placeholder = null,
  required = false,
  onChange,
  value,
  minDaysFromNow,
  min,
  max,
  step,
  type = 'date',
}) => (
  <Wrapper $singleColumn={!label}>
    {label && <Label required={required}>{label}</Label>}
    <CoreInput
      className={className}
      type={kebabCase(type)} // kebabCase for datetimeLocal
      name={name}
      placeholder={placeholder}
      required={required}
      onChange={onChange}
      value={value}
      min={formatDate(minDaysFromNow ? getDate(minDaysFromNow) : min, { type })}
      max={formatDate(max, { type })}
      step={step}
    />
  </Wrapper>
);

export default styled(DateComponent)``;
